module.exports = __webpack_public_path__ + "img/naviga_logo.67581f52.png";